import { useLang } from 'hooks/lang';

import { Notification } from 'entities';

import { Button, IconButton, overlayEscape, ResponsiveOverlay } from 'components/Blocks';

import { NotificationsIcon } from 'components/Icons';

import { SingleNotification } from './SingleNotification';
import { ActiveNotificationBadge } from './ActiveNotificationBadge';

import { useNotification } from 'providers/Notifications';

const MAX_NOTIFICATIONS_TO_SHOW = 15;

const getNotificationsToShow = (notifications: Notification[]): Notification[] =>
  notifications.slice(0, MAX_NOTIFICATIONS_TO_SHOW);

export function Notifications() {
  const { notifications, unreadNotifications } = useNotification();

  const { t } = useLang();

  const notificationsToShow = getNotificationsToShow(notifications);

  return (
    <ResponsiveOverlay
      default="pop-over"
      align="end"
      title={<h3 className="text-start text-lg text-primary">{t('notifications')}</h3>}
      largeClassName="w-fit pr-0"
      gap="0"
      trigger={
        <IconButton>
          <ActiveNotificationBadge show={!!unreadNotifications}>
            <NotificationsIcon />
          </ActiveNotificationBadge>
        </IconButton>
      }
    >
      <div className="scrollbar max-h-[65vh] w-[min(450px,95vw)] translate-x-[-2%] overflow-y-auto p-2 pb-4">
        {notificationsToShow.length ? (
          <div>
            {notificationsToShow.map((notification) => (
              <SingleNotification key={notification.id} notification={notification} />
            ))}

            <Button to="notifications" className="mt-2 w-full" onClick={() => overlayEscape()}>
              {t('view-all')}
            </Button>
          </div>
        ) : (
          <span className="inline-block w-full text-center">
            {t('looks-like-theres-nothing-here')}
          </span>
        )}
      </div>
    </ResponsiveOverlay>
  );
}
